// extracted by mini-css-extract-plugin
export var active = "_mm-2";
export var recordingDot = "_mm-1";
export var recordingIndicator = "_mm-0";